import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-turns-reports-passed-card',
  templateUrl: './turns-reports-passed-card.component.html',
  styleUrls: ['./turns-reports-passed-card.component.scss']
})
export class TurnsReportsPassedCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

}
